"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeBlock = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const unsafe_html_js_1 = require("lit/directives/unsafe-html.js");
const Prism = __importStar(require("prismjs"));
require("prismjs/components/prism-typescript");
const code_block_styles_1 = require("@/components/common/code-block/code-block.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common/icon-button/semantics/copy-button");
/**
 * 코드 스니펫 블록.
 * Prism 기본 번들 문법(markup·css·javascript)과 추가로 불러온 typescript를 하이라이팅하고,
 * 모르는 language는 하이라이팅 없이 원문 그대로 보여준다.
 * 면을 가진 프레임 안에 놓일 때는 variant="plain"으로 자기 면을 걷는다.
 *
 * <mm-code-block .code=${'<mm-avatar size="80"></mm-avatar>'}></mm-code-block>
 */
let CodeBlock = class CodeBlock extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'default';
        this.code = '';
        this.language = 'markup';
        this.copyable = true;
    }
    render() {
        return (0, lit_1.html) `
      <pre><code>${this.renderCode()}</code></pre>
      ${this.renderCopyButton()}
    `;
    }
    renderCopyButton() {
        if (!this.copyable)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-copy-button value=${this.code}></mm-copy-button>
    `;
    }
    renderCode() {
        const grammar = Prism.languages[this.language];
        if (!grammar)
            return this.code;
        return (0, unsafe_html_js_1.unsafeHTML)(Prism.highlight(this.code, grammar, this.language));
    }
};
CodeBlock.styles = [shared_styles_1.resetStyles, code_block_styles_1.codeBlockStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], CodeBlock.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CodeBlock.prototype, "code", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], CodeBlock.prototype, "language", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], CodeBlock.prototype, "copyable", void 0);
CodeBlock = __decorate([
    (0, decorators_js_1.customElement)('mm-code-block')
], CodeBlock);
exports.CodeBlock = CodeBlock;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29kZS1ibG9jay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvZGUtYmxvY2sudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2QkFBK0M7QUFDL0MscURBQTJEO0FBQzNELGtFQUEwRDtBQUMxRCwrQ0FBZ0M7QUFDaEMsK0NBQTRDO0FBRTVDLHdGQUFrRjtBQUNsRiwrREFBeUQ7QUFDekQsaUVBQThEO0FBSTlEOzs7Ozs7O0dBT0c7QUFFSSxJQUFNLFNBQVMsR0FBZixNQUFNLFNBQVUsU0FBUSxnQkFBVTtJQUFsQzs7UUFFc0MsWUFBTyxHQUFxQixTQUFTLENBQUE7UUFDcEQsU0FBSSxHQUFHLEVBQUUsQ0FBQTtRQUNULGFBQVEsR0FBRyxRQUFRLENBQUE7UUFDbEIsYUFBUSxHQUFHLElBQUksQ0FBQTtJQXVCOUMsQ0FBQztJQXJCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTttQkFDSSxJQUFJLENBQUMsVUFBVSxFQUFFO1FBQzVCLElBQUksQ0FBQyxnQkFBZ0IsRUFBRTtLQUMxQixDQUFBO0lBQ0gsQ0FBQztJQUVPLGdCQUFnQjtRQUN0QixJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVsQyxPQUFPLElBQUEsVUFBSSxFQUFBOzhCQUNlLElBQUksQ0FBQyxJQUFJO0tBQ2xDLENBQUE7SUFDSCxDQUFDO0lBRU8sVUFBVTtRQUNoQixNQUFNLE9BQU8sR0FBRyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQTtRQUM5QyxJQUFJLENBQUMsT0FBTztZQUFFLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQTtRQUU5QixPQUFPLElBQUEsMkJBQVUsRUFBQyxLQUFLLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFBO0lBQ3ZFLENBQUM7O0FBMUJNLGdCQUFNLEdBQUcsQ0FBQywyQkFBVyxFQUFFLG1DQUFlLENBQUMsQ0FBQTtBQUNIO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzBDQUFzQztBQUNwRDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7dUNBQVU7QUFDVDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7MkNBQW9CO0FBQ2xCO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzsyQ0FBZ0I7QUFMakMsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsZUFBZSxDQUFDO0dBQ2xCLFNBQVMsQ0E0QnJCO0FBNUJZLDhCQUFTIn0=